import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './TaskDescriptionTip.messages.tsx';

export const TaskDescriptionTip = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Text size="small" color="color.text">
			<Text weight="bold">{formatMessage(messages.tipLabel)} </Text>
			{children}
		</Text>
	);
};
